import React, { useState, useEffect, useMemo } from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import CookieDisclaimer from "../components/CookieDisclaimer";
import SEO from "../components/SEO";
import "../styles.css";

// Static game data with reviews
export const gameReviews = [
    {
      id: 125,
      title: "007 First Light",
      poster: "https://images.igdb.com/igdb/image/upload/t_cover_big/coaoiz.png",
      rating: 10,
      review: [
        "007 First Light is phenomenal — I enjoyed every single chapter and everything IO Interactive threw at me, and I genuinely hope this becomes a full Bond series because I want more of what they delivered here.",
        "It blends satisfying combat, proper stealth, and Hitman-style opportunities with an Uncharted-style story on top; I have only played Hitman 1, but this felt just as good while standing firmly on its own.",
        "The graphics look great, the younger Bond story was written well enough to win over my scepticism, and Patrick played a brilliant Bond — with Lenny Jones and Gemma Chan involved, I kept wishing for a new film with this exact cast.",
        "I loved that it is not all in-your-face action: you can stealth, bluff your way out, and the block-and-grab combat is super satisfying, especially when more enemies pile in and start attacking at the same time for a genuinely challenging scrap.",
        "Not much to dislike, though the opening is a bit slow, the two-gadget limit (three later) felt unnecessarily restrictive when optional loadouts could have offered an easier mode, takedown prompts sometimes punched instead of grabbing and alerted guards, connection errors were constant, and you cannot drag bodies to hide them.",
        "None of that stopped me from loving it start to finish — one of the best spy games I have played in years."
      ],
      category: ["Action", "Adventure", "Stealth"],
      streamed: true,
      releaseYear: 2026,
      platinumed: false,
      platform: "PS5 Pro",
      allTimeFav: false,
      vodUrl: ""
    },
    {
      id: 124,
      title: "Grand Theft Auto IV",
      poster: "https://images.igdb.com/igdb/image/upload/t_cover_big/co2lbv.png",
      rating: 9,
      review: [
        "Many players still praise Grand Theft Auto IV for its weightier driving and physics, and I ended up loving that too because the cars feel grounded rather than floaty like in some other entries.",
        "The story is easily the highlight, packed with memorable characters, a darker tone, and great side activities like the comedy club with Ricky Gervais and Katt Williams, while dating perks such as Kiki removing wanted levels add a surprisingly useful layer to the open world.",
        "My \"law abiding citizen\" playthrough made Liberty City feel fresh, since taking taxis, stopping at red lights, and avoiding random assault turned the game into a weirdly fun roleplay challenge, especially because most missions are not timed.",
        "That said, the illusion breaks when traffic behind me gets mad at a red light or a police car rear-ends me and somehow I get the wanted star, which feels unfair and hilarious in the worst way.",
        "I also missed removed features like planes, car buying, stronger stealth options, and silenced weapons, because those would have made a more restrained playstyle much smoother.",
        "The PC version also deserves its rough reputation, with players on sites like MobyGames and guides like PCGamingWiki regularly pointing out bugs, instability, and the need for community fixes.",
        "Even with its dull brown atmosphere, lost vehicles, and technical headaches, GTA IV remains one of Rockstar's strongest games because its story, physics, side content, and roleplay potential still make Liberty City worth returning to."
      ],
      category: ["Action", "Open World"],
      streamed: true,
      releaseYear: 2008,
      platinumed: false,
      platform: "PC",
      allTimeFav: false,
      vodUrl: "https://www.youtube.com/playlist?list=PLTu3-2LVeFgvDi5C2qkw9Ufo40fb2eMw9"
    },
    {
      id: 123,
      title: "Assassin's Creed Mirage: Valley of Memory",
      poster: "https://images.igdb.com/igdb/image/upload/t_cover_big/coapkg.png",
      rating: 9,
      review: ["Just played through Valley of Memory and I'm really impressed with what Ubisoft delivered here. The fact that this was free makes it even better - we don't see enough quality free DLC these days.",
      "The story adds some nice depth to Basim's character before his transition in Valhalla, and the new AlUla region is absolutely stunning. The desert landscapes and historical sites like Hegra are beautifully rendered. What really impressed me was how emotional this story was - Lee Majdoub's voice acting has definitely improved, bringing real depth to Basim's struggles with regret and longing. The motion capture scenes were also a step up from Shadows, making the emotional moments land much better than the base game did.",
      "My main complaint is that it's a bit too short - I would have loved maybe 2-3 more hours of main story content. But for what's there, it's quality over quantity, and the emotional beats actually land well.",
      "One small gripe was getting used to the controls again - coming from Shadows where dodge is mapped to circle, but Mirage uses square instead. That's really on Shadows for changing the established controller layout, but it took a bit to unlearn the muscle memory.",
      "No real complaints from me beyond the length. It's a solid send-off for Basim's story and a great addition to the Mirage experience. If you enjoyed the base game, this is definitely worth playing."],
      category: ["Action", "Adventure", "Open World"],
      streamed: true,
      releaseYear: 2025,
      platinumed: true,
      platform: "PS5 Pro",
      allTimeFav: false,
      vodUrl: "https://youtube.com/live/Yimlig0vax8?feature=share"
    },
    {
      id: 122,
      title: "Assassin's Creed Shadows: Claws of Awaji",
      poster: "https://images.igdb.com/igdb/image/upload/t_cover_big/co9bfw.png",
      rating: 6,
      review: ["Claws of Awaji feels like content that should have been in the base game, providing narrative closure for Naoe's mother (Fujibayashi Tsuyu) on Awaji Island. The DLC delivers around 8 hours of content, but it's essentially more of the same Shadows formula rather than anything groundbreaking.",
      "The new Bo staff weapon adds some combat variety, though I found myself rarely using it. Yasuke gets some new abilities and his own Templar storyline that runs parallel to Naoe's journey.",
      "The highlight is undoubtedly the Nowaki boss fight, a stealth-based encounter in a swamp environment that channels Metal Gear Solid vibes with its cat-and-mouse gameplay, traps, and decoys. It's tense, strategic, and a refreshing change from the typical spongey boss battles. Speaking of which, other bosses like Imagawa Tomeji and Kimura Yukari still suffer from massive health bars and relentless unblockable attacks that feel more tedious than challenging.",
      "Tsuyu's character didn't quite resonate with me - she comes across as too bold and not particularly assassin-like. The story follows the predictable 'bad guys capture family member' formula, and while it provides closure, it doesn't add much depth to the overall narrative. The 2.5D puppet show intro was a creative touch though.",
      "Ultimately, Claws of Awaji is a solid expansion that improves on some of the base game's weaknesses, particularly in mission design and dialogue. However, it plays it too safe and doesn't justify its existence as separate DLC. Free with pre-orders, it's worth playing for Shadows fans, but it won't convert anyone who wasn't already invested in the base game."],
      category: ["Action", "Adventure", "Open World"],
      streamed: true,
      releaseYear: 2025,
      platinumed: true,
      platform: "PS5 Pro",
      allTimeFav: false,
      vodUrl: "https://www.youtube.com/playlist?list=PLTu3-2LVeFgtqvVBf8BmlxHsqkFZPn2jr"
    },
    {
      id: 121,
      title: "Far Cry 6",
      poster: "https://images.igdb.com/igdb/image/upload/t_cover_big/co2npg.png",
      rating: 7,
      review: [
      "Having played a couple of Far Cry games before, I came in with a decent idea of what to expect and for the most part, it delivers. The story is genuinely engaging, and Antón Castillo makes for a memorable antagonist; Giancarlo Esposito absolutely owns the role and gives the game a nastier, more cinematic edge than the series usually manages.",
      "The Amigos are much more fleshed out compared to Far Cry 5, adding a fun and charming layer to the experience, especially with Guapo, Chorizo, and my personal favourite, Oluso.",
      "That said, the game stumbles when it comes to vehicle combat. I found myself emptying full magazines into helicopters with them still sitting at half health and no proper tool to finish the job — it felt like a genuine oversight. While I can appreciate the sheer variety of weapon choices and the Supremo additions do help, I ended up defaulting to the rocket Supremo almost every time just to reliably deal with air threats especially since the helicopters always dodged my Rocker Launcher, which says a lot about the balance.", "The open world, while beautiful, doesn't bring much new to the table and the blend of towns and wilderness feels a little too familiar if you've spent time in previous entries, and the whole thing starts to lose steam the longer you push through it.",
      "That said, Dani as a voiced protagonist was a welcome change, and the small details really shine such as hearing the voice actor hum and sing along to whatever's playing on the car radio was a genuinely lovely touch. It felt more grounded and human, and honestly I hope more games take note of it going forward.", "So overall, this game is great in bursts, but just don't expect it to reinvent the wheel too much."],
      category: ["Action", "Adventure", "Open World"],
      streamed: true,
      releaseYear: 2021,
      platinumed: false,
      platform: "PS5 Pro",
      allTimeFav: false,
      vodUrl: "https://www.youtube.com/playlist?list=PLTu3-2LVeFgvy2T9mavqBX7YKcrxwaM4A"
    },
    {
      id: 120,
      title: "Red Dead Redemption (PS5)",
      poster: "https://images.igdb.com/igdb/image/upload/t_cover_big/co2lcv.png",
      rating: 9,
      review: ["Coming back to this classic after all these years, it's clear why it left such a mark. John Marston's story is still one of the best Rockstar has ever told, backed by an atmosphere and soundtrack that pulls you in from the first note. The Dead Eye system and gunplay hold up brilliantly, making every shootout feel cinematic and satisfying." ,"That said, the open world can feel a little lifeless and sparse compared to modern standards, and the graphics haven't received much of a facelift - with that dusty, washed-out look is very much still here. A few too many missions start to blur together by the end, but none of that stops this from being a timeless masterpiece worth revisiting."],
      category: ["Action", "Adventure", "Open World"],
      streamed: true,
      releaseYear: 2025,
      platinumed: false,
      platform: "PS5 Pro",
      allTimeFav: false,
      vodUrl: "https://www.youtube.com/playlist?list=PLTu3-2LVeFgviZ_80YpaJrZT5HehfIMxs"
    },
    {
      id: 119,
      title: "Avatar: Frontiers of Pandora",
      poster: "https://images.igdb.com/igdb/image/upload/t_cover_big/co9oe3.png",
      rating: 7,
      review: ["Avatar Frontiers of Pandora is one of those games that immediately grabs you with how gorgeous it looks. Pandora feels alive in a way that makes you want to just stop and take it all in, and getting your Ikran early means you can do exactly that from the sky whenever you feel like it.", "If you have ever played a Far Cry game you will feel right at home here as the gameplay loop is very familiar, from the way you approach outposts to how you explore and gather resources across a big open world.", "The story surprised me too. It plays things a little safe but it kept me hooked and genuinely made me care about what was happening.", "Combat and crafting are where things get a little shaky though. Fights are fun when they get going but start to feel samey after a while, and the harvesting system in particular takes way too long to click. I basically had to look up how it worked which is a bit of a letdown.", "Throw in a bug or two (as usual with Ubisoft) that completely stopped my game from progressing during character creation and you have a game that has real potential but trips over itself a little too often. Still a solid game and worth your time if you love the Avatar franchise and the beautiful open world it offers."],
      category: ["RPG", "Adventure"],
      streamed: true,
      releaseYear: 2023,
      platinumed: true,
      platform: "PS5 Pro",
      allTimeFav: false,
      vodUrl: "https://www.youtube.com/playlist?list=PLTu3-2LVeFguAOTBWYm5juMsIIZsrDat-"
    },
    {
      id: 118,
      title: "Tomb Raider 1 (Remastered)",
      poster: "https://images.igdb.com/igdb/image/upload/t_cover_big/co8xte.png",
      rating: 5,
      review: ["It's been ages since I last played Tomb Raider, and wow, it really showed! My streaming attempt didn't go too well since I had to follow a guide while trying to keep up with chat at the same time.", "The remastered graphics look absolutely amazing, and I love that you can switch between the original and modern visuals on the fly.", "The modern controls are a nice addition, though it took me a few levels to get used to them. As much as the classic tank controls are notoriously tricky, I kind of wish they'd made the modern controls feel a bit more like the originals.", "Actually, it would've been perfect if you could use both at once such as maybe using the d-pad for tank controls and analog sticks for modern, so you could switch seamlessly for those precise jumps and of course the famous corner glitch.", "However...let's address the elephant in the room...Glitches. I had soo many glitches that messed up my collectibles and secrets where it would either show 2/3 secrets but then I collected all items which makes zero sense. I experienced this once in one of the Egypt levels and twice in the most disliked level...Natla's Mines.", "So unfortunately I had to give up out of frustration which is a shame because I really enjoyed this game without it's issues."],
      category: ["Strategy", "Adventure"],
      streamed: true,
      releaseYear: 2024,
      platinumed: false,
      platform: "PS5 Pro",
      allTimeFav: false,
      vodUrl: ""
    },
    {
      id: 117,
      title: "Uncharted: The Lost Legacy (Remastered)",
      poster: "https://images.igdb.com/igdb/image/upload/t_cover_big/co4eiy.png",
      rating: 9,
      review: ["Chloe is my favourite character, so playing from her perspective was a real highlight", "for a DLC, I was pleasantly surprised by how much open exploration it offers", "the environments look fantastic, and I actually preferred them to Uncharted 4's locations", "The downside is that it's very short and can be finished in around six hours even with all collectibles", "I would've liked a Nate cameo, but it's understandable why he isn't here and it was nice to see Sam show up.", "Interesting to see Nadine included however I didn't feel she added much to the game and was just someone that tagged along."],
      category: ["Action", "Adventure"],
      streamed: true,
      releaseYear: 2022,
      platinumed: false,
      platform: "PS5 Pro",
      allTimeFav: false,
      vodUrl: "https://www.youtube.com/playlist?list=PLTu3-2LVeFgtSA5Vo4m3tORusisf4f4Rg"
    },
    {
      id: 116,
      title: "Uncharted 4: A Thief's End (Remastered)",
      poster: "https://images.igdb.com/igdb/image/upload/t_cover_big/co4eiw.png",
      rating: 8,
      review: ["Uncharted 4: A Thief’s End is a stunning finale for Nathan Drake, with an excellent story, fantastic performances, and top-tier presentation—from gorgeous, richly detailed environments and ruins to a memorable score and even the charming Crash Bandicoot minigame, all boosted further by 120fps support in the Legacy of Thieves remaster.", "The game gives you more room than past entries to play stealthily instead of defaulting to constant shootouts, and the Legacy of Thieves upgrade path is great value at around $10 if you already own Uncharted 4 or Lost Legacy.", "On the downside, platforming deaths can feel inconsistent when short drops sometimes kill you while bigger ones don’t, the remaster can be buggy (occasional void spawns and minigame glitches), aim assist makes fine headshots a fight with the controller, and some chapters lock you out of backtracking if you miss collectibles.","While you might miss having more characters like Chloe here, she gets her moment in The Lost Legacy","This game makes for a must-play experience for Uncharted fans and action-adventure fans."],
      category: ["Action", "Adventure"],
      streamed: true,
      releaseYear: 2022,
      platinumed: false,
      platform: "PS5 Pro",
      allTimeFav: false,
      vodUrl: "https://www.youtube.com/playlist?list=PLTu3-2LVeFgvCyoXwiMEk2IOJEWb3g4ST"
    },
    {
      id: 115,
      title: "Watch Dogs 2",
      poster: "https://images.igdb.com/igdb/image/upload/t_cover_big/co2p3j.png",
      rating: 8,
      review: ["Watch Dogs 2 delivers a much more vibrant and playful experience than the first game, with excellent parkour, a fun, quirky lead in Marcus, and a likable DedSec crew (Sitara, Horatio, Wrench) that many reviewers highlight as a big step up from Aiden and Chicago’s gloomier tone", "The game leans hard into its San Francisco Playground, offering tons of side activities—from stealthy hacking missions to “Driver SF” Uber-style gigs and selfies at landmarks—plus stylish customization and 3D-printed gear that most critics agree makes the open world feel energetic and alive", "On the downside, driving can feel floaty and inconsistent (not far from your “rubber banding” complaint), some story threads and returning characters are underused, and the main narrative is shorter and lighter than you might expect, with occasional tonal clashes between goofy hacktivism and mass-murder shootouts especially for a character who just doesn't fit that 'killer' vibe.", "However, many people enjoyed Watch Dogs 2 thanks to its freer, more creative gameplay and stronger cast, even if some design quirks—like vehicle handling and how little control you get over your teammates for most of the campaign—hold it back from being truly outstanding."],
      category: ["Action", "Open World"],
      streamed: true,
      releaseYear: 2016,
      platinumed: false,
      platform: "PS4",
      allTimeFav: false,
      vodUrl: "https://www.youtube.com/playlist?list=PLTu3-2LVeFgt_m9hZrnQOsaST2iDXiK4C"
    },
    {
      id: 114,
      title: "Control",
      poster: "https://images.igdb.com/igdb/image/upload/t_cover_big/co2evj.webp",
      rating: 6,
      review: ["Control just wasn’t the game for me, even though I can see why some people love it. The atmosphere and visual style are striking, but the story often feels deliberately vague and hard to follow. I struggled to grasp what was really going on or why I should care about the larger plot, and the constant lore dumps and cryptic documents never quite came together into anything satisfying for me.", "The gameplay starts out fine and the powers are fun at first, but combat quickly becomes repetitive. Most encounters boil down to clearing yet another wave of similar enemies in rooms that begin to blur together. After a while, it felt more like I was going through the motions than actually enjoying the fights.", "The biggest frustration, though, was the map and navigation. The layout of the Oldest House is confusing, and the in‑game map doesn’t do a good job of helping you make sense of its multiple floors and similar-looking areas. I also didn’t find a clean way to view other floors on the map unless I fast-traveled to a point on that level, which made backtracking and objective hunting feel clunky and unintuitive. For a game that expects you to explore, the navigation design works against you.", "Overall, Control has style and some cool ideas, but for me the confusing storytelling, repetitive combat, and poor map design added up to a mixed experience. I would have given it a 5 but I am adding 1 point thanks to the perfect timing of adding PS5 Pro patch support so I could utilise the full power of my PS5 Pro."],
      category: ["Action", "Adventure"],
      streamed: true,
      releaseYear: 2019,
      platinumed: false,
      platform: "PS5 Pro",
      allTimeFav: false,
      vodUrl: "https://www.youtube.com/playlist?list=PLTu3-2LVeFgtcnYx-p52OiRpcimixsfbw"
    },
    {
      id: 113,
      title: "A Plague Tale: Requiem",
      poster: "https://images.igdb.com/igdb/image/upload/t_cover_big/co5pwb.png",
      rating: 9,
      review: ["A Plague Tale: Requiem builds brilliantly on the first game with an even stronger story, excellent cast and voice acting, and snappier gameplay.", "With a faster, infinite-ammo sling, a flexible skill system that adapts to your playstyle along with some quality of life tweaks such as a chapter and a checkpoint select and of course the circle button to crouch.", "New tools like the crossbow, more upgrades, weapon skins, and a close-quarters counter deepen combat, though helmeted enemies can feel overly restrictive without a crossbow or fire, and the Devorantis absence is puzzling.", "The knives are a mixed bag which are useful but limited, especially for trophy hunters who need them for secret chests and on-the-go upgrade can make workbenches feel redundant.", "There was a missed opportunity to reuse the hawk-avoidance level as it was just a one time event. Despite this, this is a refined, engrossing sequel I highly recommend."],
      category: ["Adventure", "Stealth"],
      streamed: false,
      releaseYear: 2022,
      platinumed: true,
      platform: "PS5 Pro",
      allTimeFav: false,
      vodUrl: "https://www.youtube.com/playlist?list=PLTu3-2LVeFgvc2aLrVN_TJgc7Ftoclp_H"
    },
    {
      id: 112,
      title: "Death Stranding: Director's Cut",
      poster: "https://images.igdb.com/igdb/image/upload/t_cover_big/co4rjc.png",
      rating: 8,
      review: ["Death Stranding Director’s Cut delivers a phenomenal, emotionally resonant story brought to life by a stellar cast especially where each character’s arc matters and has their own role to play in the game. Its world is gorgeous and atmospheric, making exploration compelling even when the landscape feels sparse.", "Traversal is the star: balancing your load, plotting routes, and building roads and zip-lines create a deeply satisfying loop, with late-game gear (bikes, skeletons, weapons) turning preparation into real payoff. There’s less combat than expected but a nice combination of weapons, and the strand tool in particular makes encounters snappy and stylish. Crafting and fabrication offer a rich sense of progression, and even resource-heavy projects like auto‑pavers feel rewarding once completed.", "Vehicle handling is clunky and can be frustrating, with odd behaviour when switching from reverse to acceleration and often getting stuck which requires constant jumping to get out of sticky situations. Stealth against Mules feels undercooked with not many objects to use for sneaking except for tall grasses and detection ranges make sneaking unreliable and limit tactical options. Over time, BTs lose their early menace and become more of a navigational inconvenience than a true threat.", "Despite some rough edges in driving and stealth, this is a singular, beautifully designed journey whose systems, atmosphere, and audacious storytelling make it easy to recommend."],
      category: ["Action", "Adventure"],
      streamed: true,
      releaseYear: 2021,
      platinumed: false,
      platform: "PS5 Pro",
      allTimeFav: false,
      vodUrl: "https://www.youtube.com/playlist?list=PLTu3-2LVeFgvqxxpuycZ_62Ud7ZXrhRit"
    },
    {
      id: 111,
      title: "Scarlet Nexus",
      poster: "https://images.igdb.com/igdb/image/upload/t_cover_big/co3b6l.png",
      rating: 5,
      review: ["Scarlet Nexus shines with stylish comic book–style cutscenes and slick UI that look fantastic on an OLED, and its brain crush finishers feel incredibly satisfying.", "I loved the clever password system tied to the TV show, which extends the experience beyond the game, and the crafting options for weapons and gifts help save money.", "Bond episodes and SAS mechanics deepen both character relationships and combat by letting you borrow teammates’ powers. However, the story—especially around Phases 2 and 3 moves too fast and can feel overwhelming, while the flashy visuals don’t add much beyond surface-level appeal.", "Constant tutorial pop-ups interrupt the flow in combat, and Bond Episodes sometimes clash tonally with main story events.", "Finally, dodging feels overly strict and imprecise compared to similar games, which made even minor encounters frustrating, less enjoyable and ultimately pushed me to step away."],
      category: ["RPG", "Action", "Adventure"],
      streamed: true,
      releaseYear: 2021,
      platinumed: false,
      platform: "PS5",
      allTimeFav: false,
      vodUrl: "https://www.youtube.com/playlist?list=PLTu3-2LVeFguY039UlFQaoMPvTpql9I4B"
    },
    {
      id: 110,
      title: "Clair Obscur: Expedition 33",
      poster: "https://images.igdb.com/igdb/image/upload/t_cover_big/co9gam.png",
      rating: 9,
      review: ["A stunning blend of artful worldbuilding, evocative music, and striking character design, Expedition 33 delivers a heartfelt story with memorable personalities and a fresh turn-based system enhanced by timing-based dodges and parrys.", "Difficulty options support story-focused playstyles, and robust post-game content plus New Game+ extend the experience well beyond the credits.", "On the downside, onboarding for the skill and lumina systems can feel overwhelming until mid-game, and collectibles (especially music records) lack elegant tracking.", "Side quests are largely absent, gradient attacks/blocks may feel extraneous, and enemy variety (mainly among the Mimes) can be repetitive, though recent patches like auto-advance for dialogue improve quality of life.", "Despite nitpicks, this is a polished, emotionally resonant RPG that showcases impressive craft and direction.", "I believe this will win Game of the Year 2025."],
      category: ["RPG", "Turn-based strategy", "Adventure"],
      streamed: true,
      releaseYear: 2025,
      platinumed: true,
      platform: "PS5 Pro",
      allTimeFav: false,
      vodUrl: "https://www.youtube.com/playlist?list=PLTu3-2LVeFgvUx_EWSKg5mNfnk94g8aAC"
    },
    {
      id: 109,
      title: "Deus Ex: Mankind Divided",
      poster: "https://images.igdb.com/igdb/image/upload/t_cover_big/co25jt.png",
      rating: 8,
      review: ["Mankind Divided refines the series with deep augmentation choices, stronger stealth systems, and a rich cyberpunk narrative carried by meaningful side content and dialogue-driven outcomes.", "The visuals impress and the shift away from frequent boss battles supports a more story-forward experience, echoing the strengths of Human Revolution.", "However, the main story feels shorter, Prague’s playable area is limited, and reliance on trains can make traversal feel cumbersome.", "UI quirks—like mission markers auto-switching—and the lack of a stats screen undermine trophy pursuits such as Foxiest of the Hounds, while the PS5 version’s absence of 60 fps support disappoints.", "Completionists will want a guide due to numerous missable trophies, but overall this is a polished and engaging entry in the franchise"],
      category: ["Action", "Stealth"],
      streamed: true,
      releaseYear: 2016,
      platinumed: false,
      platform: "PS4",
      allTimeFav: false,
      vodUrl: "https://www.youtube.com/playlist?list=PLTu3-2LVeFgtM3Kg9KePt56eLPeFfJ9k1"
    },
    {
      id: 108,
      title: "Alien: Isolation",
      poster: "https://images.igdb.com/igdb/image/upload/t_cover_big/co1vzu.png",
      rating: 9,
      review: "An incredible horror game. As a fan of the Alien series, I feel Creative Assembly really captured the atmosphere of the Alien universe. The game is well-paced and the story is engaging. The graphics are stunning for an 11 year old game and the sound design is top-notch. The AI used for the Alien is so advanced that it beats all AI in other games even to this day. I did experience a few bugs with the game that required reloading a save or quitting the game and relaunching it, but overall it is a must-play for fans of the Alien series. Just be ready to crap your pants. Can't wait for the sequel!",
      category: ["Horror"],
      streamed: true,
      releaseYear: 2014,
      platinumed: true,
      platform: "PS4",
      allTimeFav: false,
      vodUrl: "https://www.youtube.com/playlist?list=PLTu3-2LVeFgvW1HQc3FcXYNefW4RI3PdI"
    },
    {
      id: 107,
      title: "Spyro Reignited Trilogy",
      poster: "https://images.igdb.com/igdb/image/upload/t_cover_big/co1tjo.png",
      rating: 10,
      review: ["I am a big Spyro fan and as someone who grew up with Spyro through the PS1 days, I was not going to pass on the remake. The story was just as it is but with better visuals and music. Tom Kenny who voiced Spyro in the 2nd and 3rd game reprised his role for the whole trilogy which I am glad because he was the better VA in my opinion.", "The world design and character building is top-notch. You don't really forget any character and they all have a completely different personality to the point you might just love them all! I wasn't a fan of some character re-designs like Hunter and Sheila but all other designs were great!", "I won't lie, the 10/10 rating is mainly because of nostalgia but I was smiling all the way from start to finish. Toys For Bob really hit the nail on this one. Well done!"],
      category: ["Action", "Adventure" ],
      streamed: false,
      releaseYear: 2018,
      platinumed: true,
      platform: "PS4",
      allTimeFav: true,
    },
    {
      id: 106,
      title: "Watch Dogs: Bad Blood",
      poster: "https://images.igdb.com/igdb/image/upload/t_cover_big/co1zp4.png",
      rating: 8,
      review: "The DLC for Watch Dogs focused on T-Bone Grady, where you had to help an old friend from Blume. I am glad we got more from T-Bone as he was a great character that was underused in the main game. The story can be done in 4 hours but those 4 hours were worth the time.",
      category: ["Action", "Open World"],
      streamed: true,
      releaseYear: 2014,
      platinumed: false,
      platform: "PS4",
      vodUrl: "https://youtube.com/live/ssZE5Wz4lgQ?feature=share"
    },
    {
      id: 105,
      title: "Watch Dogs",
      poster: "https://images.igdb.com/igdb/image/upload/t_cover_big/co2p5w.png",
      rating: 8,
      review: "I played this for the first time in 2025. It was a lot of fun and I enjoyed roaming the streets of Chicago and the ability to hack cameras, traffic lights, and blow up steam pipes. I enjoyed the story and Aiden was great character. Although the story was a classic revenge story, but the cat-and-mouse missions and creative sandbox hijinks more than make up for it. Overall, a smart, stylish open-world experience",
      category: ["Action", "Open World"],
      streamed: true,
      releaseYear: 2014,
      platinumed: false,
      platform: "PS4",
      vodUrl: "https://www.youtube.com/playlist?list=PLTu3-2LVeFgtVKeYX_7cJpb87AzRMRJ__"
    },
    {
      id: 104,
      title: "Grand Theft Auto III: The Definitive Edition",
      poster: "https://images.igdb.com/igdb/image/upload/t_cover_big/co65yy.png",
      rating: 6,
      review: ["A remaster that failed to iron out the annoying issues in the original game. The soundtrack is great containing mostly music from the Scarface film. I am happy that auto-save is available and that when you fail a mission, you can simply retry without having to backtrack. The AI really sucks and is so unfair when you are at the mercy of them being stupid to finish missions/challenges.", "I do wish they increased the vehicle health as it is so easy to destroy your car when gangs get aggro, and also they somehow still kept the Mafia having shotguns when they are against you resulting in your car being destroyed in a couple of shots. To platinum this, you best do all side stuff on that island before you proceed to the Main missions. Overall, a solid game but not the best."],
      category: ["Action", "Open World" ],
      streamed: true,
      releaseYear: 2021,
      platinumed: true,
      platform: "PS4",
      vodUrl: "https://www.youtube.com/playlist?list=PLTu3-2LVeFgtj06rXVgZEpyTnhIJIhKkH"
    },
    {
      id: 103,
      title: "Grand Theft Auto Vice City: The Definitive Edition",
      poster: "https://images.igdb.com/igdb/image/upload/t_cover_big/co65yz.png",
      rating: 7,
      review: ["Going back to Vice City through the Definitive Edition was a real treat. There's something special about diving back into this classic with better graphics and some much needed improvements. I was smart to wait for the patches since everyone was complaining about how buggy it was at launch, and I'm glad I did because my experience was pretty smooth.", "The graphics upgrades aren't going to blow your mind or anything, but they definitely make the game look better. The lighting is improved, the character models look cleaner, and Vice City's neon soaked streets have more pop to them. Sure, it's not going to compete with modern games visually, but it does enough to make the whole 80s vibe feel fresh again without losing what made the original so memorable.", "The real game changer though is the quality of life stuff they added. Having auto save and better checkpoints is honestly a godsend. Anyone who played the original remembers the pain of failing a mission and having to drive all the way back across the map just to try again. Those days are thankfully over, and it makes the whole experience so much more enjoyable. You can actually focus on having fun instead of worrying about losing progress.", "The story itself is pretty short compared to the other games in the trilogy, but honestly that works in its favour. Everything feels tight and focused. Tommy's rise through the criminal underworld moves at a good pace, and you never feel like missions are just there as filler. Every part of the story actually matters, which is refreshing."],
      category: ["Action", "Open World" ],
      streamed: true,
      releaseYear: 2021,
      platinumed: true,
      platform: "PS4",
      vodUrl: "https://www.youtube.com/playlist?list=PLTu3-2LVeFgv8Z94dcPCu1Wkr7aNxUwft"
    },
    {
      id: 102,
      title: "Grand Theft Auto San Andreas: The Definitive Edition",
      poster: "https://images.igdb.com/igdb/image/upload/t_cover_big/co65z0.png",
      rating: 9,
      review: ["The best GTA out of the trilogy and maybe the best of all time! I feel this game has more to do then even GTA 4 and GTA V. I feel all characters are written so well and the amount of content may feel overwhelming but it keeps you entertained. The gang turf wars are a nice addition. I feel they could have done a better job with the vehicle import/export mission and also the girlfriend benefits could be better but I recommend the ones that allow you to keep your weapons when you get Wasted/Busted.", "There was a ton of collectibles and I am glad the stunt jumps were not required for the Platinum trophy. The story is engaging and there are a lot of fun missions. I do wish they added a bit more to the stealth mechanic as there were only two missions that utilize it but not fully. Pretty sad they didn't make a San Andreas Stories like they did for GTA III and Vice City but San Andreas is definitely my favorite GTA out of the trilogy."],
      category: ["Action", "Open World" ],
      streamed: true,
      releaseYear: 2021,
      platinumed: true,
      platform: "PS4",
      vodUrl: "https://www.youtube.com/playlist?list=PLTu3-2LVeFgvN0vgHTwnZpfAxHunUemlV"
    },
    {
      id: 101,
      title: "The Precinct",
      poster: "https://images.igdb.com/igdb/image/upload/t_cover_big/co9la1.png",
      rating: 7,
      review: ["The Precinct has this really cool concept where it's basically GTA but flipped around so you're playing as the cop instead of the criminal. The top down view works great and really captures that classic GTA feel, which is exactly what drew me to it. The 1980s setting is pretty neat too, and mixing actual police work like writing tickets with car chases and shootouts keeps things interesting.", "The problem is it's got some annoying bugs that break up the flow, and the story is probably the most cliché police plot you can imagine. You're the son of a cop, your father gets killed, and surprise, there's corruption in the department. It's like they took every police movie trope and just mashed them together. Plus the map feels pretty small so you can get around it way too quickly.", "Still, if you can get past the generic story and don't mind the occasional bug, it's a fun time that scratches that GTA itch from a different angle"],
      category: ["Simulator", "Indie" ],
      streamed: true,
      releaseYear: 2025,
      platinumed: false,
      platform: "PS5 Pro",
      vodUrl: "https://www.youtube.com/playlist?list=PLTu3-2LVeFgv4syqBjHhjQ9TtLkNCSTWQ"
    },
    {
      id: 100,
      title: "Assassin's Creed Shadows",
      poster: "https://images.igdb.com/igdb/image/upload/t_cover_big/co87cu.png",
      rating: 7,
      review: ["I'm gonna say it. I liked Assassin's Creed Shadows. The long awaited setting in Japan and the season changes were a welcome addition. The gameplay was pretty solid and mixture of Mirage and Odyssey. The story was...meh, the characters stories were not as engaging as I expected them to be and the voice acting for some characters was just abysmal which has been going on a downhill trend after Origins. Stealth is improved and the additional weapons along with the dual protoganist system felt you had more options to choose from. It was nice that you can pick either Naoe or Yasuke during missions but their alliance didn't feel as strong as I wanted it to be, more like they just tagged along with each other and that's it.", "I preferred Yasuke's story but if I had to be honest, I still would have preferred a dual japanese protogonist choice and have Yasuke's story as a DLC because they added stuff to Yasuke's story which did not happen such as the relationship option with Nobunaga's sister, like...come on! Really? Also not much was known about him so it would have been a good opportunity to make his story feel like a secret story which would have been suitable for DLC. But overall, this game was fun to play and I am looking forward to playing the Claws of Awaji DLC in September."],
      category: ["Action", "Stealth", "Open World" ],
      streamed: true,
      releaseYear: 2025,
      platinumed: true,
      platform: "PS5 Pro"
    },
    {
      id: 99,
      title: "Breath of Fire IV",
      poster: "https://images.igdb.com/igdb/image/upload/t_cover_big/co6opw.png",
      rating: 10,
      review: ["My all-time favourite RPG game. Outside of Pokémon, this was my first RPG game I played before going into Final Fantasy. With all other RPG games out there, I always find myself coming back to this every few years or so. I love the story, the art direction is beautiful, soundtrack is one of the best and it has all the core RPG mechanics you need in a classic RPG. There are times it's too easy and times it gets challenging.", "The mini-games are quite fun such as the fishing and also the skill and combo system. It doesn't hold your hand with the combos so I had to learn it by trial and error, and to learn a skill, you had to know if the enemy is using a learnable skill and guard when they use it. It doesn't always work but you get there in the end.", "Each character has a pretty unique story of their own and you really learn about their past and how they developed into the character they become. So there isn't really any dead-weight in your team.", "There is a long standing battle in the community on whether Breath of Fire III or Breath of Fire IV is better. I know I am biased but since this is my first Breath of Fire game I played, I can't help but say it's my favourite due to the memories I had with it. I also prefer the art style over the 3rd game which is more cartoony. If you love RPGs and Turn-based strategy games, this is a must play. I highly recommend it."],
      category: ["RPG", "Turn-based strategy", "Adventure" ],
      streamed: true,
      releaseYear: 2000,
      platinumed: false,
      platform: "PS1",
      allTimeFav: true
    },
    {
      id: 98,
      title: "A Plague Tale: Innocence",
      poster: "https://images.igdb.com/igdb/image/upload/t_cover_big/co1lat.png",
      rating: 9,
      review: ["Can't believe I haven't played this for so long but here we go. This is absolutely stunning both visually and emotionally. The story follows Amicia and her little brother Hugo as they try to survive in plague-ridden medieval France, and it really pulls at your heartstrings. The bond between the siblings feels genuine and develops beautifully throughout the game.", "The gameplay is mostly stealth-based puzzle solving, which works perfectly with the atmosphere they're going for. You're not some overpowered hero, just a teenage girl trying to protect her sick brother, so the vulnerability feels real. The rats are genuinely terrifying and create this constant sense of dread, but the way you use light to navigate around them is clever.", "The visuals are incredible for what it is, with some really beautiful environments that make the dark subject matter feel almost artistic. It's not super long but it doesn't overstay its welcome either. If you're into story-driven games with strong emotional moments, this one's definitely worth playing."],
      category: ["Adventure", "Stealth" ],
      streamed: true,
      releaseYear: 2019,
      platinumed: true,
      platform: "PS5 Pro",
      vodUrl: "https://www.youtube.com/playlist?list=PLTu3-2LVeFguapH1MoNfGdK1QdlWePTm1"
    },
    {
      id: 97,
      title: "Persona 3 Reload",
      poster: "https://images.igdb.com/igdb/image/upload/t_cover_big/co6z12.png",
      rating: 10,
      review: ["....Wow. Nostalgia hit hard with this remake. As soon as they announced this game, I was the happiest I have ever been. This is the best Persona game imo. The story is top notch, the soundtrack is amazing even where a lot of songs have been redone. And the added mechanics such as the Theurgy and Shift system were a nice addition for modern players. Once I finished this game, I was literally just sitting there and speechless on what I just experienced. Atlus really know how to make good RPG games. I will get to the The Answer DLC at some point but for now I need to saviour this moment."],
      category: ["RPG" ],
      streamed: true,
      releaseYear: 2024,
      platinumed: true,
      platform: "PS5",
      allTimeFav: true
    },
    {
      id: 96,
      title: "The Last of Us Part 1",
      poster: "https://images.igdb.com/igdb/image/upload/t_cover_big/coa1gq.png",
      rating: 9,
      review: ["The best PS3 game ever, remade for PS5. At first I was a little sceptical on this because it was a remake of an already impressive graphical game slapped with a £70 price tag. But I bought it when it went down to about £45 and I thoroughly enjoyed it. My only gripe was that they didn't add some of the mechanics from Part II such as the dodge and silencer mods. But they did improve the overall stuff like the Bow and how enemy AI works.", "Looking forward to playing Part II Remastered on PS5 Pro."],
      category: ["Adventure", "Stealth", "Horror"],
      streamed: true,
      releaseYear: 2022,
      platinumed: false,
      platform: "PS5"
    },
    {
      id: 95,
      title: "Zenless Zone Zero",
      poster: "https://images.igdb.com/igdb/image/upload/t_cover_big/co90je.png",
      rating: 9,
      review: ["Another banger from mihoyo. This is a fun game. Really enjoyed the combat and storyline. The agent designs are pretty cool and not overly exaggerated. I do find the Exploration missions boring (the part where you navigate through TVs) and much prefer to more combat than puzzle quests. Overall it is a fun game and I prefer this game over Genshin Impact and Honkai Star Rail."],
      category: ["RPG", "Action", "Beat 'em up"],
      streamed: true,
      releaseYear: 2024,
      platinumed: true,
      platform: "PS5"
    },
    {
      id: 94,
      title: "Astro Bot",
      poster: "https://images.igdb.com/igdb/image/upload/t_cover_big/co8hl0.png",
      rating: 10,
      review: ["Very fun game and enjoyed every minute of it. Soundtrack was good especially loved the remix music for the after-boss levels where you play as different characters. The PS levels were a nice challenge and some were tough especially the very last one.", "There is a story but it isn't anything ground-breaking which isn't really a big deal for a game like this as the developers main focus was the gameplay, content and the overall fun you will experience.", "Only two issues with it was when you find the vortex in levels, they would just eject you out of the whole level and so you have to redo the level again. And the difficulty curve wasn't balanced right for me. Some levels felt like it was starting to be a bit tougher and then suddenly the next few levels were a walk in the park didn't really offer much but just a section to take photos of random stuff but nothing exciting there.", "Only experienced one bug, however it is a very well made, polished game and it deserver it's GOTY 2024 award."],
      category: ["Platform", "Action", "Adventure"],
      streamed: true,
      releaseYear: 2024,
      platinumed: true,
      platform: "PS5",
      allTimeFav: true
    },
    {
      id: 93,
      title: "PowerWash Simulator",
      poster: "https://images.igdb.com/igdb/image/upload/t_cover_big/co7gek.png",
      rating: 5,
      review: ["This is an okay game but not my kind of game. Personally I had a lot of problems where I would have a game crash two or three times every day but luckily you lose almost zero progress when that happens. There is no music at all in this game or for what I experienced. I also finished the game with all trophies however I have that annoying glitched trophy with finishing the story which apparently will be patched in the next update but I feel it will be awhile when we see that. It's an okay game to play if you want to have a chill session though.", "The patch was released later on and I was able to nab the platinum trophy for it."],
      category: ["Simulator", "Indie"],
      streamed: false,
      releaseYear: 2022,
      platinumed: true,
      platform: "PS5"
    },
    {
      id: 92,
      title: "Grand Theft Auto V",
      poster: "https://images.igdb.com/igdb/image/upload/t_cover_big/co66nd.png",
      rating: 9,
      review: ["Throughly enjoyed GTA 5. I did a law abiding citizen run of the game where I cannot break laws outside of missions including speeding and traffic laws. It was fun to do. The story of the game is great as I remember and the gameplay is solid as usual for a GTA game."],
      category: ["Action", "Open World"],
      streamed: true,
      releaseYear: 2013,
      platinumed: false,
      platform: "PS5"
    },
    {
      id: 91,
      title: "Mirror's Edge Catalyst",
      poster: "https://images.igdb.com/igdb/image/upload/t_cover_big/co28r2.png",
      rating: 8,
      review: ["A great game that was enough to Platinum. The first person view with the parkour really made it fun to roam around the city. The open world didn't really feel that big to me to be honest as I was also going through usual routes to get to destinations. Thankfully there are no more gun combat like in the first game which was very clunky so I guess EA felt that it just didn't work and just went with the melee combat instead.", "The collectibles are bit much and you will have to replay missions to get some that are locked behind in those specific missions. The timed missions were near impossible to complete without without a guide on the best way to beat it, it expected you to be an absolute pro at the game which I definitely wasn't." ,"The story didn't really entice me much and it was just generic. Soundtrack is amazing and really enjoyed. I played this before the servers shutdown so I was able to get that Platinum. Overall a great game and I wish EA made another Mirror's Edge."],
      category: ["Platform", "Action", "Adventure"],
      streamed: true,
      releaseYear: 2016,
      platinumed: true,
      platform: "PS4"
    },
    {
      id: 90,
      title: "Honkai: Star Rail",
      poster: "https://images.igdb.com/igdb/image/upload/t_cover_big/coa8yk.png",
      rating: 8,
      review: ["Finally got the Platinum for this game. Although there is still much need to be done such as companion missions and other content. I enjoyed the game a lot even though the gacha system latched onto me thanks to Acheron being released.", "I am a big fan of the Turn-based strategy in RPGs and I do love the way it is implemented in this game. As usual the story is not too bad but I am still a bit confused with the plot. I even forgot the buzzwords like Stellaron etc. The characters you get are all very unique and Mihoyo does a great job with their style and combat usage.", "My one issue with this is I feel once they release a new character, it becomes so OP that it will power through the story for you but then a few updates later, that same character is just dead-weight. I felt this especially with Seele who was the first S banner character. It just feels like a cheeky way for mihoyo to make money off of the gacha system."],
      category: ["RPG", "Turn-based strategy", "Adventure"],
      streamed: true,
      releaseYear: 2023,
      platinumed: true,
      platform: "PS5"
    },
    {
      id: 89,
      title: "Tekken 8",
      poster: "https://images.igdb.com/igdb/image/upload/t_cover_big/co7lbb.png",
      rating: 8,
      review: ["I am definitely not the best at fighting games but Tekken is one game I will always make time for as I enjoy the combat in it. Managed to platinum this game in 11 hours which is quite short. The main story is very short even though it has 15 chapters but it's focus isn't about the story in my opinion but the combat (Even though it is better than COD MW III campaign. Ooof too soon?). I will come back to this when new DLC characters arrive but glad they have Leroy and some new characters added to the game. One gripe with the online matches is the matchmaking is a bit weird especially for Group matches as I was being faced with much much higher ranked players. Overall fun game though."],
      category: ["Action", "Stealth", "Open World"],
      streamed: true,
      releaseYear: 2024,
      platinumed: true,
      platform: "PS5"
    },
    {
      id: 88,
      title: "Yakuza: Like a Dragon",
      poster: "https://images.igdb.com/igdb/image/upload/t_cover_big/co2em9.png",
      rating: 9,
      review: ["What a great move to the RPG genre. Like a Dragon was one of my favourites RPGs to play recently. The story was great and Ichiban is a great and funny character. The RPG mechanics were fun and love the Poundmates feature. Visuals are of course not on par with most AAA titles but this is a Yakuza game so the graphics are what you expect."],
      category: ["RPG", "Turn-based strategy", "Adventure"],
      streamed: true,
      releaseYear: 2020,
      platinumed: true,
      platform: "PS5"
    },
    {
      id: 87,
      title: "Marvel's Spider-Man 2",
      poster: "https://images.igdb.com/igdb/image/upload/t_cover_big/co79vq.png",
      rating: 8,
      review: ["Definitely the better game out of the three. Story was amazing but after Sandman, I felt it took too long to start giving me a boss fight but when it did, there were boss fights continuously. Gameplay is improved, web wings are awesome and playing as both Peter and Miles was nice. I wish they added a little more collectibles as this game only took 25 hours to platinum."],
      category: ["Beat 'em up", "Adventure"],
      streamed: true,
      releaseYear: 2023,
      platinumed: true,
      platform: "PS5"
    },
    {
      id: 86,
      title: "Mass Effect Legendary Edition",
      poster: "https://images.igdb.com/igdb/image/upload/t_cover_big/co6dq9.png",
      rating: 7,
      review: ["First time playing this. Story was good and enjoyable. Gameplay could really do better as navigating the UI was tedious and I couldn't get used to it through-out the game."],
      category: ["RPG", "Strategy", "Adventure"],
      streamed: true,
      releaseYear: 2021,
      platinumed: false,
      platform: "PS5"
    },
    {
      id: 85,
      title: "Marvel's Spider-Man: Miles Morales",
      poster: "https://images.igdb.com/igdb/image/upload/t_cover_big/co2dwe.png",
      rating: 9,
      review: ["The best thing to do when making a game is not change the good stuff but improve on the other parts. The story of this game is short but the skills and costumes are impressive. Miles is a great character and just shows you how tough it can be when you're newly acquainted in the Spider-Man role."],
      category: ["Action", "Open World" ],
      streamed: true,
      releaseYear: 2020,
      platinumed: true,
      platform: "PS5"
    },
    {
      id: 84,
      title: "Marvel's Spider-Man",
      poster: "https://images.igdb.com/igdb/image/upload/t_cover_big/co1r77.png",
      rating: 9,
      review: ["I am sure a lot of people remember the PS2 Spider-Man 2 days and ever since then web swinging was just...meh. Well Insomniac broke that curse and gave us the best web swinging game we could ever hoped for. A superb game that was a great contestant to God of War (which won GOTY 2018). Looking forward to playing the remaster on PS5 as well as a direct sequel."],
      category: ["Beat 'em up", "Adventure"],
      streamed: true,
      releaseYear: 2018,
      platinumed: true,
      platform: "PS5"
    },
    {
      id: 83,
      title: "Persona 3: Dancing in Moonlight",
      poster: "https://images.igdb.com/igdb/image/upload/t_cover_big/co1ob9.png",
      rating: 8,
      review: ["I am one of many that are just hoping Atlus to make a remaster of Persona 3 FES but until then I went to platinum Dancing in Moonlight.", "I am not much of a dancing gamer but the nostalgia hit hard with the music and the storyline is quite interesting. Going from 100+ hours in Persona 3 to 9 hours in this game is a significant difference but I had fun with it!"],
      category: ["Music"],
      streamed: false,
      releaseYear: 2018,
      platinumed: true,
      platform: "PS Vita"
    },
    {
      id: 82,
      title: "Detroit: Become Human",
      poster: "https://images.igdb.com/igdb/image/upload/t_cover_big/co6mzf.png",
      rating: 8,
      review: ["This game is a gripping, choice-driven sci‑fi thriller that lets your decisions steer the narrative with more weight and clarity than most games in its genre. I do wish the storytelling sometimes showed more restraint, given how much nuance the tech and performances are capable of delivering. Even so, the core trio is so convincingly written and acted that I felt real anxiety when they were at risk and a genuine rush when they pulled through. Best of all, Detroit lays out its branching routes in a way that invites replays, and its decisions stick—raising tension and consequences from start to finish."],
      category: ["Adventure"],
      streamed: false,
      releaseYear: 2018,
      platinumed: true,
      platform: "PS4"
    },
    {
      id: 81,
      title: "Star Wars Jedi: Fallen Order",
      poster: "https://images.igdb.com/igdb/image/upload/t_cover_big/co1rbi.png",
      rating: 8,
      review: ["The best Star Wars game I have played. The combat is a lot of fun and one of the best stories I have played on a Star Wars game. It's lacking on worlds to explore and perhaps would like more of free roaming but the combat, customisation and story has been great. The map was left to be desired though as it was very tedious to navigate especially when you need to fill the map up and get all the collectibles. However it was a joy to play and was able to platinum it on my PS5."],
      category: ["Action", "Adventure"],
      streamed: true,
      releaseYear: 2019,
      platinumed: true,
      platform: "PS5"
    },
    {
      id: 80,
      title: "Resident Evil 7: biohazard",
      poster: "https://images.igdb.com/igdb/image/upload/t_cover_big/co8uu1.png",
      rating: 7,
      review: ["This was actually my first time playing a Resident Evil game since I am a big scaredy cat. I was pleasantly surprised by the game even with all the jumpscares and weird characters but that makes them unique. Not sure if I am a big fan of Ethan as I didn't really felt like you got to know about his character that much and that he is only the husband of Mia and he is searching for her while monsters are out to get him and he just tanks all the damage dealt at him.", "Since this game is set in a house complex, I felt quite claustrophobic and it did make me slightly uncomfortable in many areas which I think was the purpose the developers had in mind. I wouldn't say it is something I would go out of my way to play again however it was a good experience."],
      category: ["Horror"],
      streamed: true,
      releaseYear: 2017,
      platinumed: false,
      platform: "PS5"
    },
    {
      id: 79,
      title: "Jak and Daxter",
      poster: "https://images.igdb.com/igdb/image/upload/t_cover_big/co1w7q.png",
      rating: 10,
      review: ["This was my first ever PS2 game which I got at Xmas. I had so many fond memories playing this franchise such as a time when I had no memory card so I had to keep starting the game all over again even if I completed it the day before. I was so happy to finally get to play it on PS3 and then PS4 and also PS5. I've even platinumed it on PS Vita.", "The story is so good and the combat is so much fun. I completely forgot that there are no loading screens and it is just one continuous experience in a small world with many areas to explore. I also love the characters and the world it takes place in. It is quite an easy game for me since I probably played this over 100 times which led me to get the platinum in under 7 hours. Daxter is one of my favourite characters and has the greatest humour. It's a must play for anyone who likes platformers and adventure games."],
      category: ["Action", "Adventure"],
      streamed: true,
      releaseYear: 2001,
      platinumed: true,
      platform: "PS5",
      allTimeFav: true
    },
    {
      id: 17,
      title: "Assassin's Creed Mirage",
      poster: "https://images.igdb.com/igdb/image/upload/t_cover_big/co57sj.png",
      rating: 7,
      review: ["Funny enough, I played Mirage before I even played Valhalla and I think this made me appreciate Basim a lot more. I can understand why people didn't like his character after playing Valhalla before this. The plot twist at the end was unexpected but that was about it. The game is gorgeous but it doesn't factor in that the story just ends the way it does. Not many memorable missions and the only characters I know are Basim, Nehal and Roshan. That's about it.", "I prefer the stealthy gameplay approach and that fighting just one enemy can lead to death if you are not careful vs all the previous games where you can take on a whole army. So stealth is much more focused and I am here for it."],
      category: ["Action", "Stealth", "Open World" ],
      streamed: true,
      releaseYear: 2023,
      platinumed: true,
      platform: "PS5"
    },
    {
      id: 16,
      title: "Assassin's Creed Valhalla",
      poster: "https://images.igdb.com/igdb/image/upload/t_cover_big/co2ed3.png",
      rating: 6,
      review: ["Assassin’s Creed Valhalla is an ambitious game, but it ultimately feels like a double-edged sword. While it delivers a vast open world and plenty of content, its length and design choices often detract from the overall experience.", "The main issue lies in the game’s emphasis on quantity over quality, a mistake reminiscent of Assassin’s Creed Unity. Unlike Unity, which was eventually patched and became a solid experience, Valhalla struggles under the weight of its overstuffed content. The story, in particular, is too long and meandering, causing it to lose focus. Some arcs feel disconnected, making it easy to forget about key characters like Sigurd and Basim, who should have been central to the narrative. While the story does improve near the end, the journey there often feels like a slog.", "For players attempting to achieve the Platinum trophy, the game’s design choices can be especially frustrating. Collecting everything on the map, which is a requirement for completionists, feels more like an exercise in tedium than an enjoyable challenge. Compared to Assassin’s Creed Origins, which also had a lot to collect but balanced it with a more concise and rewarding experience, Valhalla feels like it’s dragging you along for eternity.", "That’s not to say the game is without its merits. The world is beautifully crafted, and the Viking setting is both rich and immersive. However, the excessive length and focus on filler content detract from what could have been a truly memorable experience.", "In the end, Valhalla might appeal to players who enjoy sprawling open-world games and don’t mind sinking countless hours into exploration. For others though, it may feel like an over-extended journey that prioritizes quantity over quality."],
      category: ["Action", "Stealth", "Open World" ],
      streamed: true,
      releaseYear: 2020,
      platinumed: true,
      platform: "PS5"
    },
    {
      id: 15,
      title: "Assassin's Creed Odyssey: The Fate of Atlantis",
      poster: "https://images.igdb.com/igdb/image/upload/t_cover_big/co92cr.png",
      rating: 7,
      review: ["A great DLC where you get to explore Elysium, The Underworld and Atlantis all separated through 3 episodes. The story focused on Layla but it didn't really grasp my attention as much. It's atmosphere in each area was what nailed it right but it was just a ordinary DLC in the end."],
      category: ["Action", "Stealth", "Open World" ],
      streamed: true,
      releaseYear: 2019,
      platinumed: false,
      platform: "PS5"
    },
    {
      id: 14,
      title: "Assassin's Creed Odyssey: Legacy of the First Blade",
      poster: "https://images.igdb.com/igdb/image/upload/t_cover_big/co1i02.png",
      rating: 6,
      review: ["Story wise, it is much better than Fate of Atlantis DLC as you have Darius who made the story more interesting. The story got a bit cringey and then suddenly the story goes from 'okay...' to 'wtf?'. It feels as if Ubisoft didn't really care about how people chose their story and instead erased what they had then with their own Kassandra/Alexios build. I wish the DLC was focused on Darius and his life in Persia. That could have set a new tone for the series."],
      category: ["Action", "Stealth", "Open World" ],
      streamed: true,
      releaseYear: 2018,
      platinumed: false,
      platform: "PS5"
    },
    {
      id: 13,
      title: "Assassin's Creed Odyssey",
      poster: "https://images.igdb.com/igdb/image/upload/t_cover_big/co2nul.png",
      rating: 7,
      review: ["One of my least favourite AC games but if I separate the 'Assassin' from the game then it is amazing. I am not a fan of how you have to hit enemies with 100s of hits in order to kill them, and the assassinate doesn't one hit kill enemies which is funny as other AC games have stayed true to this. The platinum wasn't as grindy and it only took me 68 hours to get it which I was expecting much longer. The story is okay but not Origins level of writing but the world map is one of my favourites."],
      category: ["Action", "Stealth", "Open World" ],
      streamed: true,
      releaseYear: 2018,
      platinumed: true,
      platform: "PS5"
    },
    {
      id: 12,
      title: "Assassin's Creed Origins: The Curse of the Pharaohs",
      poster: "https://images.igdb.com/igdb/image/upload/t_cover_big/co22pv.png",
      rating: 8,
      review: ["This DLC shocked me with the amount of content in it. I wasn't expecting to have visited the afterlifes as well get to explore another region. The story goes very much further into the myth side of things and while it was an okay story, when it finished, it wasn't as a great ending I expected especially after playing The Hidden Ones DLC (Which is the best AC DLC I ever played)."],
      category: ["Action", "Stealth", "Open World" ],
      streamed: false,
      releaseYear: 2018,
      platinumed: false,
      platform: "PS5"
    },
    {
      id: 11,
      title: "Assassin's Creed Origins: The Hidden Ones",
      poster: "https://images.igdb.com/igdb/image/upload/t_cover_big/ltz2icwpzaeqe2uu4xsx.png",
      rating: 9,
      review: ["This is one of the best DLC in my opinions in any AC game. It's a great story that tells the workings of the brotherhood and the good and bad decisions made. I wish there was some kind of way you can call upon your fellow Assassin's like AC Brotherhood."],
      category: ["Action", "Stealth", "Open World" ],
      streamed: false,
      releaseYear: 2018,
      platinumed: false,
      platform: "PS5"
    },
    {
      id: 10,
      title: "Assassin's Creed Origins",
      poster: "https://images.igdb.com/igdb/image/upload/t_cover_big/co1rbe.png",
      rating: 10,
      review: ["So, my second time playing AC Origins and I appreciate it a lot more and describe this as the perfect game when going into the RPG style. The story is top notch, the gameplay is different than previous franchises but it is easy to get used to and OMG the voice acting is awesome especially that scene with Bayek saying 'Sleep? I never sleep' when you assassinate The Heron. Abubakar Salim knocked it out of the park with this one and sadly this is the last AC game I played that has this phenomenal voice acting. The graphics are amazing and soundtrack is one of the best. I have to rank this in my top 3 of AC games and it's perfect. It's so perfect that I actually got all the achievements on Steam as well as platinumed it on my PS5. My only gripe with this game is there is no Amunet DLC. A DLC based on when she is in Rome in the BC era would have been amazing. However the game is still a solid experience and I recommend it to fans of the series."],
      category: ["Action", "Stealth", "Open World" ],
      streamed: false,
      releaseYear: 2017,
      platinumed: true,
      platform: "PS5",
      allTimeFav: true
    },
    {
      id: 9,
      title: "Assassin's Creed Syndicate",
      poster: "https://images.igdb.com/igdb/image/upload/t_cover_big/co1xis.png",
      rating: 8,
      review: ["At first I gave Syndicate a hard time because it felt like a complete 180 from Unity as that game made combat slow and so I felt like Ubisoft knew that and decided to make Syndicate like a street fighter game. I got used to the combat slightly though. This used to be my least favourite AC but I grew to love Evie and the story of this game a lot more.", "I went back to the game to finish off the Platinum trophy. Good news, they added the 60 FPS patch to PS5 and Xbox Series so I was able to play with better smooth gameplay."],
      category: ["Action", "Stealth", "Open World" ],
      streamed: true,
      releaseYear: 2015,
      platinumed: true,
      platform: "PS4"
    },
    {
      id: 8,
      title: "Assassin's Creed Unity",
      poster: "https://images.igdb.com/igdb/image/upload/t_cover_big/co1xiq.png",
      rating: 7,
      review: ["This was a massive step up in terms of gameplay and graphics which still hold to this day. The graphics still beat recent titles and the parkour is more refined and realistic albeit it is a bit slow. The combat feels slow for me and wish it was a little more refined and responsive. The story is okay while I only remember a few characters, but I pretty much enjoyed it. I wish Ubisoft made a 60 FPS patch on PS5 as it is still capped at 30 FPS. I prefer the multi-player in this as the missions have a lot of replay value. The collectiables however, nope. I hate the fact that the map is over populated with sooo many icons and it shows that Ubisoft really prioritized quatity over the quality of the content."],
      category: ["Action", "Stealth", "Open World" ],
      streamed: true,
      releaseYear: 2014,
      platinumed: false,
      platform: "PS4"
    },
    {
      id: 7,
      title: "Assassin's Creed Rogue Remastered",
      poster: "https://images.igdb.com/igdb/image/upload/t_cover_big/co1xit.png",
      rating: 5,
      review: ["I haven't actually played the OG version of this game so I just delved into the remaster and here we go...Ugh. Yeah...I would like to 'Make my own luck' especially after hearing it 100 times from Shay. I am not a fan of the 'Assassin's are bad guys' approach to the story and if you know me well, I hate snow and there is quite a bit in this game especially when you spend a lot of time in cold weathers. "],
      category: ["Action", "Stealth", "Open World" ],
      streamed: true,
      releaseYear: 2018,
      platinumed: false,
      platform: "PS4"
    },
    {
      id: 6,
      title: "Assassin's Creed IV: Black Flag",
      poster: "https://images.igdb.com/igdb/image/upload/t_cover_big/co4qfn.png",
      rating: 10,
      review: ["Pirates? Assassins? Shanties? Open World? This is what I define as a masterpiece of a game. Sure, they kinda abandoned the story of Desmond but Edward Kenway is such an amazing and fun character to play, and playing this game and experiencing his journey was a treasure. The ship battles are honestly the best part and it just adds so much to the experience.", "I am skeptical of the remake because Ubisoft seemed to forget how to make a pirate game especially after the failure of Skull and Bones. I hope the remake is going to be as faithful as it can be to this masterpiece."],
      category: ["Action", "Stealth", "Open World" ],
      streamed: true,
      releaseYear: 2013,
      platinumed: false,
      platform: "PS4",
      allTimeFav: true
    },
    {
      id: 5,
      title: "Assassin's Creed III",
      poster: "https://images.igdb.com/igdb/image/upload/t_cover_big/co1xii.png",
      rating: 7,
      review: ["Here comes the end of Desmond's story. Here we play as Connor who I find is a bit of a bland character, I just find him too negative and a bit of a angry moaner. While we have great characters, the one who stole the show was Haytham. It was a bit of a twist how we started out playing as him and then finding out he was a Templar. The story is okay and the missions are fun except the snow missions. Snow in missions that make you super slow just makes me want to throw the controller.", "The homestead missions was a nice bonus and added a lot of content to the game. I had so many glitches in this game but powered through and was able to get that Platinum. Unfortunately I gave up on the platinum in the Remastered version so I recommend every play the original version."],
      category: ["Action", "Stealth", "Open World" ],
      streamed: true,
      releaseYear: 2012,
      platinumed: true,
      platform: "PS3"
    },
    {
      id: 4,
      title: "Assassin's Creed Revelations",
      poster: "https://images.igdb.com/igdb/image/upload/t_cover_big/co1xih.png",
      rating: 9,
      review: ["What an ending to an amazing trilogy. In this game you get to play not only just as Ezio but also as Altair in flashbacks. Along with the Assassin recruits, we get to explore Constantinople in the heart of the Ottoman Empire. This is by far my favourite of the Ezio Trilogy and is within my Top 3 AC games behind Origins and Black Flag."],
      category: ["Action", "Stealth", "Open World" ],
      streamed: true,
      releaseYear: 2011,
      platinumed: true,
      platform: "PS3"
    },
    {
      id: 3,
      title: "Assassin's Creed Brotherhood",
      poster: "https://images.igdb.com/igdb/image/upload/t_cover_big/co6t4d.png",
      rating: 7,
      review: ["Continuing with Ezio's story, Brotherhood is a solid entry and sequel. But I will say, this was my least favourite Ezio game. The introduction of Multiplayer made the Platinum more tedious to get. I loved that they added the Assassin recruits which was a nice touch to the system but the collectibles again just made me go 'Ugghhhh'. The story was solid and the missions were fun but I found the game was just not as engaging as the previous one. However it still ranks the same as Assassin's Creed II and I still recommend it."],
      category: ["Action", "Stealth", "Open World" ],
      streamed: true,
      releaseYear: 2010,
      platinumed: true,
      platform: "PS3"
    },
    {
      id: 2,
      title: "Assassin's Creed II",
      poster: "https://images.igdb.com/igdb/image/upload/t_cover_big/co1rcf.png",
      rating: 8,
      review: ["A massive improvement from the 1st game. The character of Ezio Auditore is just fun and loveable and his story really does capture the sad and good moments of his life. The fast travel of this game is still a bit meh but extra weapons, combat and armour is a nice extra."],
      category: ["Action", "Stealth", "Open World" ],
      streamed: true,
      releaseYear: 2009,
      platinumed: true,
      platform: "PS3"
    },
    {
      id: 1,
      title: "Assassin's Creed",
      poster: "https://images.igdb.com/igdb/image/upload/t_cover_big/co1rrw.png",
      rating: 7,
      review: ["I will not mock this game at all because it is what started a franchise that I love truly. The game can be short and completed in just around 10 hours, the lack of fast travel doesn't help and the mini-map can be tedious to find what you are looking for. The graphics were great at it's time and I think it still looks good for today's standards. Really wish Ubisoft gave us a Remake as Altair's character is so iconic and is what I call the OG Assassin. Besides Bayek of course"],
      category: ["Action", "Stealth", "Open World" ],
      streamed: true,
      releaseYear: 2007,
      platinumed: false,
      platform: "PS3"
    }
];

export default function Games() {
  const [games, setGames] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [visibleCount, setVisibleCount] = useState(9);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedCategory, setSelectedCategory] = useState("All Games");

  // Store upcoming games separately
  const upcomingGames = useMemo(() => ([
    {
      id: 210,
      title: "Tomb Raider: Legend",
      poster: "https://images.igdb.com/igdb/image/upload/t_cover_big/co1nnv.png",
      rating: null,
      review: ["The first reboot of the TR series which I played back in 2006 and really enjoyed it. Will be going for the Platinum now that it is on PS5."],
      category: ["Upcoming", "Action", "Adventure"],
      streamed: false,
      releaseYear: 2006,
      platinumed: false,
      platform: "PS5 Pro",
      allTimeFav: false,
      vodUrl: ""
    },
    {
      id: 211,
      title: "Assassin's Creed Black Flag Resynced",
      poster: "https://images.igdb.com/igdb/image/upload/t_cover_big/cobyue.png",
      rating: null,
      review: ["Well it is finally coming! Pre-ordered and so ready when it comes out in July!"],
      category: ["Upcoming", "Action", "Adventure"],
      streamed: false,
      releaseYear: 2026,
      platinumed: false,
      platform: "PS5 Pro",
      allTimeFav: false,
      vodUrl: ""
    },
  ]), []);

  // Combine all games
  const allGames = useMemo(() => [...gameReviews, ...upcomingGames], [upcomingGames]);

  useEffect(() => {
    // Simulate loading games data
    const loadGames = async () => {
      try {
        setLoading(true);
        // Here you would fetch from RAWG API or your own database
        // For now, using static data
        setTimeout(() => {
          setGames(allGames);
          setLoading(false);
        }, 1000);
      } catch (err) {
        setError("Failed to load games");
        setLoading(false);
      }
    };

    loadGames();
  }, [allGames]);

  const categories = useMemo(() => {
    const baseCategories = games.flatMap(game => game.category).filter(cat => cat !== "Upcoming");
    return ["Upcoming", "All Games", "All Time Fav", ...new Set(baseCategories)];
  }, [games]);

  // Create a fresh copy of games for filtering to avoid any mutations
  const gamesForFiltering = useMemo(() => [...games], [games]);

  let displayGames = [...gamesForFiltering]; // Create a copy to avoid mutations
  if (selectedCategory === "All Time Fav") {
    displayGames = displayGames.filter(game => game.allTimeFav);
  } else if (selectedCategory === "All Games") {
    displayGames = displayGames.filter(game => !game.category.includes("Upcoming"));
  } else if (selectedCategory === "Upcoming") {
    displayGames = displayGames.filter(game => game.category.includes("Upcoming"));
  } else {
    displayGames = displayGames.filter(game => game.category.includes(selectedCategory));
  }
  if (searchTerm) {
    displayGames = displayGames.filter(game =>
      game.title.toLowerCase().includes(searchTerm.toLowerCase())
    );
  }
  const paginatedGames = displayGames.slice(0, visibleCount);

  const handleLoadMore = () => {
    setVisibleCount(v => v + 9);
  };

  const handleCategoryChange = (category) => {
    setSelectedCategory(category);
    setVisibleCount(9); // Reset pagination when changing categories
    setSearchTerm(""); // Clear search when changing categories
  };

  const renderStars = (rating) => {
    const stars = [];
    const fullStars = Math.floor(rating / 2);
    const hasHalfStar = rating % 2 >= 1;

    for (let i = 0; i < fullStars; i++) {
      stars.push(<i key={i} className="fas fa-star"></i>);
    }
    if (hasHalfStar) {
      stars.push(<i key="half" className="fas fa-star-half-alt"></i>);
    }
    const emptyStars = 5 - Math.ceil(rating / 2);
    for (let i = 0; i < emptyStars; i++) {
      stars.push(<i key={`empty-${i}`} className="far fa-star"></i>);
    }

    return stars;
  };

  return (
    <>
      <SEO
        title="Game Reviews"
        description="Read ZeMaxi's honest game reviews! From Assassin's Creed to Persona, discover ratings and detailed reviews of games streamed on Twitch. Find your next game to play!"
        keywords="game reviews, ZeMaxi reviews, Twitch streamer reviews, gaming reviews, Assassin's Creed, Persona, RPG reviews, action game reviews"
        url="https://zemaxi.com/games"
      />
      <Navbar />
      <CookieDisclaimer />
      <main>
        <section className="games-hero noise-bg">
          <div className="container">
            <h1>Game <span className="highlight">Reviews</span></h1>
            <p>Games I've streamed / will be streaming and my personal reviews</p>
          </div>
        </section>
        <section className="videos-section">
          <div className="container">
            <div className="games-search">
              <div className="search-filter-row">
                <div className="search-container">
                  <i className="fas fa-search search-icon"></i>
                  <input
                    type="text"
                    placeholder="Search games by name..."
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    className="search-input"
                  />
                  {searchTerm && (
                    <button
                      className="search-clear"
                      onClick={() => setSearchTerm("")}
                      aria-label="Clear search"
                    >
                      <i className="fas fa-times"></i>
                    </button>
                  )}
                </div>
                <div className="category-dropdown-wrapper">
                  <select
                    className="category-dropdown"
                    value={selectedCategory}
                    onChange={(e) => handleCategoryChange(e.target.value)}
                  >
                    {categories.map(cat => (
                      <option key={cat} value={cat}>{cat}</option>
                    ))}
                  </select>
                  <i className="fas fa-chevron-down category-dropdown-arrow"></i>
                </div>
              </div>
            </div>
            <div className="games-list">
              {loading && (
                <div className="video-loading">
                  <div className="spinner"></div>
                  <p>Loading game reviews...</p>
                </div>
              )}
              {error && (
                <div className="video-loading">
                  <p style={{ color: 'red' }}>Failed to load games: {error}</p>
                </div>
              )}
              {!loading && !error && paginatedGames.length === 0 && (
                <div className="video-loading">
                  <p>No games found.</p>
                </div>
              )}
              {!loading && !error && paginatedGames.map(game => (
                <div className={`game-review-item ${game.allTimeFav ? 'all-time-fav' : ''} ${game.category.includes('Upcoming') ? 'upcoming-game' : ''}`} key={game.id} style={{'--poster-bg': `url(${game.poster})`}}>
                  {game.allTimeFav && (
                    <div className="all-time-fav-label">All Time Fav</div>
                  )}
                  <div className="game-content-wrapper">
                    <div className="game-poster">
                      <img src={game.poster} alt={game.title} onError={(e) => {
                        e.target.src = '/images/placeholder-game.jpg';
                      }} />
                      {game.vodUrl && (
                        <div className="game-vod-link desktop-only">
                          <a
                            href={game.vodUrl}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="vod-link"
                          >
                            <i className="fab fa-youtube"></i> Watch VOD
                          </a>
                        </div>
                      )}
                    </div>
                    <div className="game-text-content">
                      <div className="game-header">
                        <h3>{game.title}</h3>
                        <div className="game-meta">
                          {game.category.map((cat, index) => (
                            <span key={index} className="game-category">{cat}</span>
                          ))}
                          <span className="game-date-year">{game.releaseYear}</span>
                          {game.platform && (
                            <span className="platform-badge">
                              <i className="fas fa-gamepad"></i> {game.platform}
                            </span>
                          )}
                          {game.streamed && (
                            <span className="game-streamed">
                              <i className="fa fa-television"></i> Streamed
                            </span>
                          )}
                          {game.platinumed && (
                            <span className="platinum-badge">
                              <i className="fas fa-trophy"></i> Platinumed
                            </span>
                          )}
                        </div>
                        <div className="game-rating">
                          <div className="stars">
                            {game.rating ? renderStars(game.rating) : (
                              <span className="rating-placeholder">Review Coming Soon</span>
                            )}
                          </div>
                          <span className="rating-number">
                            {game.rating ? `${game.rating}/10` : ''}
                          </span>
                        </div>
                      </div>
                      <div className="game-review-content">
                        {Array.isArray(game.review) ? (
                          game.review.map((paragraph, index) => (
                            <p key={index} style={{ marginBottom: index < game.review.length - 1 ? '1rem' : '0' }}>
                              {paragraph}
                            </p>
                          ))
                        ) : (
                          <p dangerouslySetInnerHTML={{ __html: game.review }} />
                        )}
                      </div>
                      {game.vodUrl && (
                        <div className="game-vod-link mobile-only">
                          <a
                            href={game.vodUrl}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="vod-link"
                          >
                            <i className="fab fa-youtube"></i> Watch VOD
                          </a>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              ))}
            </div>
            {!loading && !error && paginatedGames.length < displayGames.length && (
              <div className="load-more-container">
                <button className="btn btn-primary" onClick={handleLoadMore}>Load More</button>
              </div>
            )}
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}
